import type Point from "./Point";

export default function triangleArea(a:Point, b:Point, c:Point) {
	// Relative coordinates avoid cancellation when a point lies exactly on an edge.
	return ((c.x - a.x)*(b.y - a.y) - (b.x - a.x)*(c.y - a.y)) /2;
};